import axios from "axios";
import { Urls } from "../../../store/urls";

export const getUrlCreationRepo = (params) => {
    return axios({
        method: "GET",
        url: Urls.URL_CREATION_API,
        params: params,
    });
};

export const postUrlCreationRepo = (data) => {
    return axios({
        method: "POST",
        url: Urls.URL_CREATION_API,
        data: data,
    });
};

export const getOneClickLoginUrlCreationRepo = (params) => {
    return axios({
        method: "GET",
        url: Urls.ONE_CLICK_LOGIN_URL_CREATION_API,
        params: params,
    });
};

export const postDownloadCSVRepo = (data) => {
    return axios({
        method: "POST",
        url: Urls.ONE_CLICK_LOGIN_URL_CREATION_API,
        data: data,
    });
};